import { PageConfig } from '../../../config/mainPageConfig';

export interface PageState {
    loading: boolean;
    pageName: string;
    formData: Record<string, unknown>;
    formBaselineHash: string | null;
    pageConfig: Partial<PageConfig>;
    isFormSubmitting: boolean;
    apiError?: unknown;
}

export const initialPageState: PageState = {
    loading: false,
    pageName: '',
    formData: {},
    formBaselineHash: null,
    pageConfig: {},
    isFormSubmitting: false
};
